import {useLocation} from "react-router-dom";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminMedicineCatalogue, getCompanies, getDosages, getMedCategories, getSeoTags } from '../reduxToolkit/features/adminPanel/medicine';

export default function useAdminMedicineData() {
  const dispatch = useDispatch();
  const {pathname}=useLocation();
  const medicine = useSelector(state => state.medicine);
  const references=[medicine.companies,medicine.categories,medicine.dosages,medicine.seoTags];
  const [attempt, setAttempt] = useState(0),[settled,setSettled]=useState(()=>medicine.adminCatalogueLoadedAt>0&&Date.now()-medicine.adminCatalogueLoadedAt<=30000&&references.every(Array.isArray)),[referenceError,setReferenceError]=useState('');
  useEffect(() => {
    let live=true;
    const stale=!medicine.adminCatalogueLoadedAt||Date.now()-medicine.adminCatalogueLoadedAt>30000;
    const requests=[dispatch(getAdminMedicineCatalogue())];
    for (const [value, action] of [[medicine.companies, getCompanies], [medicine.categories, getMedCategories],
      [medicine.dosages, getDosages], [medicine.seoTags, getSeoTags]]) {
      if (stale||!Array.isArray(value)) requests.push(dispatch(action()));
    }
    Promise.all(requests).then(results=>{if(!live)return;setSettled(true);setReferenceError(results.some(result=>result.meta.requestStatus==='rejected'&&!result.meta.condition)?'Medicine data could not be loaded. Please try again.':'');});
    return()=>{live=false;};
    // References are reused on warm navigation; editing tools refresh them after writes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, attempt, pathname]);
  const ready = medicine.adminCatalogueLoadedAt > 0 && references.every(Array.isArray);
  async function refresh() {
    const results = await Promise.all([dispatch(getAdminMedicineCatalogue({ force: true })), dispatch(getCompanies()),
      dispatch(getMedCategories()), dispatch(getDosages()), dispatch(getSeoTags())]);
    if (results.some(result => result.meta.requestStatus === 'rejected' && !result.meta.condition)) throw Error('Refresh failed');
  }
  return { ready:ready&&settled, refresh, retry: () => setAttempt(value => value + 1), error: medicine.adminCatalogueError||referenceError };
}
